jQuery(document).ready(function ($) {
  //---- Order Form -----------------------------------------------
  if ($("#OrderForm").length) {
    console.log("OrderForm");

    const orderForm = $("#OrderForm");
    const submitButton = $("#form-submit");

    const responseSuccessElement = $("#responseSuccess");

    submitButton.on("click", function (event) {
      event.preventDefault();

      const formData = new FormData(orderForm[0]);
      const formValues = {};

      formData.forEach((value, key) => {
        formValues[key] = value;
      });

      $.ajax({
        url: "/api/form/order/submit",
        type: "POST",
        data: JSON.stringify(formValues),
        contentType: "application/json",
        success: function (response) {
          console.log("response", response);
          $("#responseMessageEmail").html("");
          responseSuccessElement.html("");

          orderForm[0].reset();
        },
        error: function (error) {
          console.error("error", error);
          try {
            const response = JSON.parse(error.responseText);
            console.log("Parsed error response", response);
          } catch (e) {
            console.log("Error parsing responseText", error.responseText);
          }
        },
      });
    });
  }
});
